export const AppTileSource = {
  MPAC: 'MPAC',
  PRODUCT: 'PRODUCT'
};
export const RegulatedSectorAppTilePreferredHosting = {
  GovernmentCloud: 'governmentCloud'
};
export const Certification = {
  CLOUD_FORTIFIED: 'CLOUD_FORTIFIED',
  CLOUD_SECURITY_PARTICIPANT: 'CLOUD_SECURITY_PARTICIPANT',
  RUNS_ON_ATLASSIAN: 'RUNS_ON_ATLASSIAN'
};
export const BadgeVariant = {
  SPOTLIGHT: 'SPOTLIGHT',
  BESTSELLER: 'BESTSELLER',
  RISINGSTAR: 'RISINGSTAR',
  NEW: 'NEW'
};